export const quickStartGuide = 'https://docs.clarifai.com/clarifai-basics/community';

export const noAppsTitle = 'No apps available yet';
export const noAppsTitleOwner = 'No apps created yet';
export const noAppsSubtitle = 'This user has not created any apps at this time.';
export const noAppsSubtitleOwner = 'An app is a place for you to organize all of your content including models, workflows, inputs and more.';

export const noAppsSearchTitle = 'No results found for';
export const noAppsSearchSubtitle = 'Your search did not match any results. Please try again.';
